import { Box, Skeleton, Stack } from "@mui/material";
import styles from "./InterviewInstructorDashboard.module.css";

export default function InterviewDashboardSkeleton() {
	return (
		<div className={styles.pageWrapper}>
			<div className={styles.pageContainer}>
				<Box display="flex" width="100%" gap="20px">
					<Skeleton variant="rounded" width="100%" height="117px" />
					<Skeleton variant="rounded" width="100%" height="117px" />
					<Skeleton variant="rounded" width="100%" height="117px" />
					<Skeleton variant="rounded" width="100%" height="117px" />
				</Box>
				<div className={styles.dashboard}>
					<div className={styles.header}>
						<Skeleton width="134px" />
					</div>
					<div className={styles.dashboardBody}>
						<Skeleton width="250px" />

						<Stack direction="row" gap="10px" alignItems="center">
							<Skeleton variant="rectangular" width="510px" height="35px" />
							<Skeleton variant="rectangular" width="73px" height="35px" />
							<Skeleton variant="rectangular" width="156px" height="35px" />
						</Stack>

						<Stack spacing="5px" direction="row">
							<Skeleton variant="rectangular" width="100%" height="48px" />
							<Skeleton variant="rectangular" width="100%" height="48px" />
							<Skeleton variant="rectangular" width="100%" height="48px" />
						</Stack>

						<Stack spacing="15px">
							<Skeleton variant="rectangular" width="100%" height="91px" />
							<Skeleton variant="rectangular" width="100%" height="91px" />
							<Skeleton variant="rectangular" width="100%" height="91px" />
						</Stack>
						<Box display="flex" justifyContent="center">
							<Skeleton variant="rectangular" width="280px" height="40px" />
						</Box>
					</div>
				</div>
			</div>
		</div>
	);
}
